import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { cartApi } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const CartCtx = createContext({ cart: null, refresh: () => {}, addToCart: () => {}, updateQty: () => {}, clear: () => {} });

export function CartProvider({ children }) {
  const { user } = useAuth();
  const [cart, setCart] = useState({ items: [], total: 0, count: 0 });

  const refresh = useCallback(async () => {
    if (!user) { setCart({ items: [], total: 0, count: 0 }); return; }
    try { setCart(await cartApi.get()); } catch (e) { /* ignore */ }
  }, [user]);

  useEffect(() => { refresh(); }, [refresh]);

  const addToCart = async (product_id, qty = 1) => {
    const r = await cartApi.add(product_id, qty);
    setCart(r);
    return r;
  };
  const updateQty = async (product_id, qty) => {
    const r = await cartApi.update(product_id, qty);
    setCart(r);
    return r;
  };
  const clear = async () => {
    const r = await cartApi.clear();
    setCart(r);
    return r;
  };

  return (
    <CartCtx.Provider value={{ cart, refresh, addToCart, updateQty, clear }}>
      {children}
    </CartCtx.Provider>
  );
}

export const useCart = () => useContext(CartCtx);
